import { useNavigate, useParams } from 'react-router-dom';
import classes from './ErrorviewPage.module.css';
import { findPageData } from '../../../util/HelperFunctions';
import AccordionSideNav from '../../layout/SideNav/AccordionSideNav/AccordionSideNav';
import PageDataList from '../../../store/PageDetailData/PageDetailData';
import { useContext, useEffect, useState } from 'react';
import useValidatePageAccess from '../../../hooks/useValidatePageAccess';
import AuthContext from '../../../store/auth-context';
import { getFilteredPageDataList, getShouldValidateAccess } from '../../../util/filteredPageData';
import LoadingPage from '../../../components/UI/Loading';

/**
 * 에러 문서 페이지 컴포넌트
 */
const ErrorviewPage = () => {
  const authCtx = useContext(AuthContext);
  const newParams = useParams();
  const [params, setParams] = useState(newParams);
  const navigate = useNavigate();

  // 현재 URL params를 사용하여 pageData 찾기
  const currentPath = params['*'] || newParams['*'];

  const pageDataList = PageDataList(authCtx.userInfo);
  const pageDataRaw = findPageData(currentPath, pageDataList) || findPageData('인증 토큰 발급', pageDataList);

  // userInfo가 로딩 중일 때는 검증을 지연시킴
  const shouldValidateAccess = authCtx.isLoggedIn && authCtx.userInfo.m_no && getShouldValidateAccess(pageDataRaw.data[0], authCtx);

  // isLoggedIn = true 이고 userInfo가 아직 로딩 중일 때는 검증하지 않기 위해 userInfo.m_no = undefined 값으로 전달
  useValidatePageAccess(shouldValidateAccess);

  // 페이지가 변경되면 API 테스트 섹션에서 데이터 리셋
  useEffect(() => {
    setParams(newParams);
  }, [authCtx, newParams, pageDataRaw, navigate]);

  // userInfo가 로딩 중일 때 처리
  if (authCtx.isLoggedIn && !authCtx.userInfo.m_no) {
    return <LoadingPage message='사용자 정보를 불러오는 중...'></LoadingPage>;
  }

  // m_no에 따라 사이드 네비게이션 바에 노출되는 항목들 필터링
  const filteredPageDataList = getFilteredPageDataList(authCtx);
  
  return (
    <>
      <AccordionSideNav data={filteredPageDataList} />
      <div className={classes.container}>
        <div className={classes.section}>
          <h1 className={classes['sub-heading']}>{pageDataRaw.title} 에러</h1>
          <table>
            <colgroup>
              {[170, 700].map((width, i) => <col width={width} key={i} />)}
            </colgroup>
            <tbody>
              <tr>
                <th>코드<br />(Code)</th>
                <th>설명<br />(Description)</th>
              </tr>
              {
                pageDataRaw.data.map((item, i) => (
                  <tr key={i}>
                    <td className='text-center'>{item.code}</td>
                    <td>{item.desc}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ErrorviewPage;